import { fetchWishlist, addWishlist, removeWishlist } from '../../api/storefront'
import { adaptProducts } from '../../adapters/productAdapter'
const list = response => response?.data?.pageList || response?.data?.result || response?.data || []
export default {
  namespaced: true,
  state: { items: [], loading: false, error: '' },
  getters: { count: state => state.items.length, has: state => id => state.items.some(item => item.id === id) },
  mutations: { SET (state, { key, value }) { state[key] = value } },
  actions: {
    async load ({ commit, rootGetters }) {
      if (!rootGetters['auth/isLoggedIn']) return
      commit('SET', { key: 'loading', value: true }); commit('SET', { key: 'error', value: '' })
      try { const response = await fetchWishlist(); commit('SET', { key: 'items', value: adaptProducts(list(response)) }) }
      catch (error) { commit('SET', { key: 'error', value: error.message }) }
      finally { commit('SET', { key: 'loading', value: false }) }
    },
    async toggle ({ dispatch, getters }, product) {
      if (getters.has(product.id)) await removeWishlist(product.id)
      else await addWishlist(product.id)
      await dispatch('load')
    }
  }
}
